<template>
    <div class="card card-default">
        <div class="card-header">
            Update Team Name
        </div>

        <div class="card-body">
            <!-- Success Message -->
            <div class="alert alert-success" v-if="form.successful">
                Your team name has been updated!
            </div>

            <form role="form">
                <!-- Name -->
                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">
                    Name
                    </label>

                    <div class="col-md-6">
                        <input
                            type="text"
                            class="form-control"
                            name="name"
                            v-model="form.name"
                            :class="{ 'is-invalid': form.errors.has('name') }"
                            :disabled="!isTeamAdmin"
                        />

                        <span
                            class="invalid-feedback"
                            v-show="form.errors.has('name')"
                        >
                            {{ form.errors.get("name") }}
                        </span>
                    </div>
                </div>

                <div v-if="team.organization_type === 'brand'" class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right">
                    Workspace Slug
                    </label>

                    <div class="col-md-6">
                        <input
                            type="text"
                            class="form-control"
                            name="workspace_slug"
                            v-model="form.workspace_slug"
                            :class="{ 'is-invalid': form.errors.has('workspace_slug') }"
                            :disabled="!isTeamAdmin"
                        />

                        <span
                            class="invalid-feedback"
                            v-show="form.errors.has('workspace_slug')"
                        >
                            {{ form.errors.get("workspace_slug") }}
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right"
                        >Guess Contact Time-Zone</label
                    >

                    <div class="col-md-6">
                        <select
                            class="form-control"
                            name="guess_contact_time_zone"
                            v-model="form.guess_contact_time_zone"
                            data-test="guess-contact-time-zone"
                            :disabled="!isTeamAdmin"
                        >
                            <option :value="false">No</option>
                            <option :value="true">Yes</option>
                        </select>

                        <span
                            class="invalid-feedback"
                            v-show="
                                form.errors.has('guess_contact_time_zone')
                            "
                        >
                            {{ form.errors.get("guess_contact_time_zone") }}
                        </span>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-md-4 col-form-label text-md-right"
                        >Default Contact Time-Zone</label
                    >

                    <div class="col-md-6">
                        <select
                            class="form-control"
                            name="default_contact_time_zone"
                            v-model="form.default_contact_time_zone"
                            data-test="default-contact-time-zone"
                            :disabled="!isTeamAdmin"
                        >
                            <option value=""></option>
                            <option
                                v-for="zone in timeZonesList"
                                :key="zone"
                                :value="zone"
                            >
                                {{ formatZone(zone) }}
                            </option>
                        </select>

                        <span
                            class="invalid-feedback"
                            v-show="
                                form.errors.has('default_contact_time_zone')
                            "
                        >
                            {{ form.errors.get("default_contact_time_zone") }}
                        </span>
                    </div>
                </div>

                <!-- Update Button -->
                <div class="form-group row mb-0">
                    <div class="offset-md-4 col-md-6">
                        <button
                            type="submit"
                            class="btn btn-primary"
                            @click.prevent="update"
                            :disabled="form.busy || !isTeamAdmin"
                        >
                            Update
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import timeZones from '~/utils/timeZones';

export default {
    props: ['team', 'isTeamAdmin'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: new SparkForm({
                name: "",
                workspace_slug: "",
            }),
        };
    },

    mounted() {
        this.form.name = this.team.name;
        this.form.workspace_slug = this.team.workspace_slug;
        this.form.default_contact_time_zone = this.team.default_contact_time_zone
        this.form.guess_contact_time_zone = this.team.guess_contact_time_zone

        Bus.$on(`sparkFormUpdated.${this.form.sparkFormId}`, this.$forceUpdate)
    },
    computed: {
        timeZonesList() {
            return timeZones;
        }
    },

    methods: {
        formatZone(zone) {
            return zone.split("_").join(" ");
        },
        update() {
            const data = {...this.form};

            if (this.team.organization_type !== 'brand') {
                delete data.workspace_slug;
            }

            Spark.put(
                `/settings/teams/${this.team.id}/name`,
               data
            ).then(() => {
                Bus.$emit("updateTeam");
                Bus.$emit("updateTeams");
            });
        },
    },
};
</script>
